// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__tBnT2","checkboxInput":"styles_checkboxInput__riKY3","checkboxIcon":"styles_checkboxIcon__3afMd","text":"styles_text__uioMI","link":"styles_link__EuZCc"};
module.exports.__checksum = "160e77cc0d52"
